import React from 'react'
import styled from 'styled-components'
import { Modal } from 'reactstrap'

import { CloseIcon } from '../icons'
import { Button } from '../buttons'
import { FONTS } from '../../constants'

export const ProfileImageModal = React.memo(props => {
  const { src, isOpen, handleClose } = props

  return (
    <Modal isOpen={ isOpen } toggle={ handleClose }>
      <ModalHeader>
        <Header>{ `User's Image Profile` }</Header>
        <CloseIcon onClick={ handleClose } />
      </ModalHeader>
      <ModalBody>
        <UserImage src={ src } alt='profile_image' />
      </ModalBody>
      <Footer>
        <Button
          theme='#6c757d'
          width='70px'
          height='26px'
          onClick={ handleClose }
        >
          Close
        </Button>
      </Footer>
    </Modal>
  )
})

const UserImage = styled.img`
  width: 100%;
  height: 100%;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;
`

const ModalBody = styled.div`
  padding: 24px 16px;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`



// WEBPACK FOOTER //
// ./src/components/modal/profile-image-modal.js